import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import ItemDetails from "./components/ItemDetails";
import Cart from "./components/Cart";
import { useState, React } from "react";
import { ShoppingCartContext } from "./components/ShoppingCartContext";
import Group from "./components/Group";
import PartsList from "./components/ShowPartsList";
import CustomerDetails from "./components/CustomerDetails";
import ShowModel from "./components/ShowModel";
import ShowYear from "./components/ShowYear";
import ShowCategory from "./components/ShowCategory";
import ShowPartsList from "./components/ShowPartsList";
import ShowSubCategory from "./components/ShowSubCategory";
import Login from "./components/Login";
import CustomerRegistration from "./components/CustomerRegistration";
import AdminDashboard from "./components/AdminDashboard";
import ProtectedRouteLogin from "./components/ProtectedRouteLogin";
import ImageUpload from "./components/ImageUpload";

function App() {

  const initialShoppingCart = []
  const [shoppingCart, setShoppingCart] = useState(initialShoppingCart)



  return (
    <Router>

      <ShoppingCartContext.Provider value={{ shoppingCart, setShoppingCart }}>
        <Routes>

          <Route
            path="/"
            element={
              // Good! Do your composition here instead of wrapping <Route>.
              // This is really just inverting the wrapping, but it's a lot
              // more clear which components expect which props.

              <Home />

            }
          />

          <Route
            path="/image_upload"
            element={
              // Good! Do your composition here instead of wrapping <Route>.
              // This is really just inverting the wrapping, but it's a lot
              // more clear which components expect which props.

              <ImageUpload />

            }
          />

          <Route
            path="/home"
            element={
              // Good! Do your composition here instead of wrapping <Route>.
              // This is really just inverting the wrapping, but it's a lot
              // more clear which components expect which props.

              <Home />

            }
          />


          <Route
            path="/group"
            element={
              // Good! Do your composition here instead of wrapping <Route>.
              // This is really just inverting the wrapping, but it's a lot
              // more clear which components expect which props.

              <Group />

            }
          />

          <Route
            path="/parts"
            element={
              // Good! Do your composition here instead of wrapping <Route>.
              // This is really just inverting the wrapping, but it's a lot
              // more clear which components expect which props.

              <PartsList />

            }
          />


          <Route
            path="/item_details"
            element={
              // Good! Do your composition here instead of wrapping <Route>.
              // This is really just inverting the wrapping, but it's a lot
              // more clear which components expect which props.

              <ItemDetails />

            }
          />

          <Route
            path="/cart"
            element={
              // Good! Do your composition here instead of wrapping <Route>.
              // This is really just inverting the wrapping, but it's a lot
              // more clear which components expect which props.

              <Cart />

            }
          />

          <Route
            path="/customer_details"
            element={
              // Good! Do your composition here instead of wrapping <Route>.
              // This is really just inverting the wrapping, but it's a lot
              // more clear which components expect which props.

              <CustomerDetails />

            }
          />

          {/* new pattern after the meeting */}

          <Route
            path="/show_models"
            element={
              // Good! Do your composition here instead of wrapping <Route>.
              // This is really just inverting the wrapping, but it's a lot
              // more clear which components expect which props.

              <ShowModel />

            }
          />

          <Route
            path="/show_year"
            element={
              // Good! Do your composition here instead of wrapping <Route>.
              // This is really just inverting the wrapping, but it's a lot
              // more clear which components expect which props.

              <ShowYear />

            }
          />

          <Route
            path="/show_category"
            element={
              // Good! Do your composition here instead of wrapping <Route>.
              // This is really just inverting the wrapping, but it's a lot
              // more clear which components expect which props.

              <ShowCategory />

            }
          />

          <Route
            path="/show_sub_category"
            element={
              // Good! Do your composition here instead of wrapping <Route>.
              // This is really just inverting the wrapping, but it's a lot
              // more clear which components expect which props.

              <ShowSubCategory />

            }
          />

          <Route
            path="/show_parts_list"
            element={
              // Good! Do your composition here instead of wrapping <Route>.
              // This is really just inverting the wrapping, but it's a lot
              // more clear which components expect which props.

              <ShowPartsList />

            }
          />

          <Route
            path="/customer_registration"
            element={
              // Good! Do your composition here instead of wrapping <Route>.
              // This is really just inverting the wrapping, but it's a lot
              // more clear which components expect which props.

              <CustomerRegistration />

            }
          />

          <Route element={<ProtectedRouteLogin />}>


            <Route
              path="/admin_login"
              element={
                // Good! Do your composition here instead of wrapping <Route>.
                // This is really just inverting the wrapping, but it's a lot
                // more clear which components expect which props.

                <AdminDashboard />

              }
            />
            <Route
              path="/admin_dashboard"
              element={
                // Good! Do your composition here instead of wrapping <Route>.
                // This is really just inverting the wrapping, but it's a lot
                // more clear which components expect which props.

                <AdminDashboard />

              }
            />

          </Route>

        </Routes>


      </ShoppingCartContext.Provider>


    </Router>
  );
}

export default App;
